//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@nuxtjs/composition-api";
import SfGallery from "~/themes/fiskarsMoominDefault/components/components/molecules/SfGallery/SfGallery.vue";

export default defineComponent({
  name: "ProductGallery",
  components: { SfGallery },
  props: {
    productGallery: {
      type: Array,
      required: true,
      default: () => []
    },
  },
});
